import { FormulaCommand } from "./FormulaCommand";

export const getFormulaUids = (cmdList: FormulaCommand[]): string[] => {
  const ids = new Set<string>();
  cmdList.forEach((cmd) => {
    if (cmd.type === "attr") {
      ids.add(cmd.uid);
    }
  });
  return Array.from(ids);
};
